import {
  Autocomplete,
  Row,
  Col,
  Container,
  Header,
  Main,
  Button,
  Checkbox,
  Radio,
  RadioGroup,
  Input,
  Select,
  Slider,
  Form,
  FormItem,
  Table,
  TableColumn,
  Progress,
  Option,
  Pagination,
  Alert,
  Menu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Steps,
  Step,
  Dialog,
  Tooltip,
  Popover,
  Card,
} from 'element-ui';

export default [
  Autocomplete,
  Row,
  Col,
  Container,
  Header,
  Main,
  Button,
  Checkbox,
  Radio,
  RadioGroup,
  Input,
  Select,
  Slider,
  Form,
  FormItem,
  Table,
  TableColumn,
  Progress,
  Option,
  Pagination,
  Alert,
  Menu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Steps,
  Step,
  Dialog,
  Tooltip,
  Popover,
  Card,
];



// WEBPACK FOOTER //
// ./app/src/element-components.js